// import { FiFileText, FiAward } from "react-icons/fi";

// const reports = [
//   { title: "Market Entry Guide — UAE", sector: "Energy & Logistics", pages: 42, status: "New", desc: "Regulatory environment, logistics corridors, partnership structures, and investment incentives for Indian enterprises." },
//   { title: "Sector Brief — Germany Automotive", sector: "Manufacturing / Auto", pages: 28, status: "Updated", desc: "EV supply chain dynamics, component sourcing trends, and strategic alliances with German OEMs." },
//   { title: "Trade Intelligence — USA Pharma", sector: "Healthcare / Pharma", pages: 35, status: "New", desc: "FDA pathways, distribution networks, pricing frameworks, and clinical trial collaboration models." },
//   { title: "Investment Outlook — Japan Retail", sector: "Retail / Consumer", pages: 30, status: "Updated", desc: "E-commerce regulations, omnichannel strategies, and consumer behavior shifts post-pandemic." },
//   { title: "Agricultural Export — Brazil", sector: "Agriculture / Food", pages: 22, status: "Updated", desc: "Procurement channels, quality certification requirements, and logistics from port to market." },
//   { title: "Infrastructure Report — South Africa", sector: "Infrastructure / Energy", pages: 36, status: "New", desc: "Road, rail, and power projects open to foreign investment; PPP frameworks and local content rules." },
// ];

// const services = [
//   "Market sizing & forecasting",
//   "Competitor benchmarking",
//   "Regulatory pathway mapping",
//   "Partnership structuring",
//   "Pricing & positioning analysis",
//   "Supply chain diagnostics",
// ];

// export default function CountryCommercialReports() {
//   return (
//     <section id="reports" className="scroll-mt-28 space-y-16">
//       <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] px-8 py-14 md:px-16 md:py-20 shadow-2xl shadow-[#DB6400]/20">
//         <div className="absolute -bottom-20 -right-20 h-80 w-80 rounded-full bg-white/10 blur-3xl" />
//         <div className="absolute -top-10 -left-10 h-48 w-48 rounded-full bg-white/10 blur-2xl" />
//         <div className="relative z-10 max-w-4xl">
//           <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md border border-white/10">
//             <FiFileText className="h-4 w-4" /> Research
//           </div>
//           <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-semibold text-white leading-[0.95] tracking-tight">
//             Commercial <span className="italic font-normal">Reports</span>
//           </h2>
//           <p className="mt-6 max-w-2xl text-lg text-white/90 leading-relaxed font-light">
//             Deep-dive sectoral reports that combine macroeconomic analysis, regulatory mapping, competitive landscapes, and actionable recommendations for Indian exporters and investors.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
//         {reports.map((r) => (
//           <a key={r.title} href="#" className="group flex flex-col rounded-3xl bg-white border border-[#FEF7F4] p-8 shadow-xl shadow-black/[0.03] hover:-translate-y-2 hover:shadow-2xl hover:border-[#DB6400]/20 transition-all duration-300 relative overflow-hidden">
//             <div className="absolute top-0 left-0 h-1.5 w-full bg-gradient-to-r from-[#DB6400] via-[#F59C00] to-[#DA2128] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
//             <div className="flex justify-between items-start mb-4">
//               <span className={`text-xs font-bold px-2.5 py-0.5 rounded-full ${r.status === "New" ? "bg-[#DA2128]/10 text-[#DA2128]" : "bg-[#DB6400]/10 text-[#DB6400]"}`}>{r.status}</span>
//               <span className="text-xs text-[#9a9aab] font-medium">{r.pages} pages</span>
//             </div>
//             <h3 className="text-xl font-semibold text-[#1a1a2e] mb-2 font-['Outfit'] group-hover:text-[#DB6400] transition-colors leading-snug">{r.title}</h3>
//             <div className="text-xs font-bold text-[#DB6400] uppercase tracking-wide mb-4">{r.sector}</div>
//             <p className="text-sm text-[#6a6a7a] leading-relaxed mb-5 flex-1">{r.desc}</p>
//             <div className="flex items-center gap-2 text-sm font-semibold text-[#DA2128] group-hover:translate-x-1 transition-transform">
//               Access Report <span>→</span>
//             </div>
//           </a>
//         ))}
//       </div>

//       <div className="rounded-3xl bg-[#FAF7F2] p-10 md:p-14 border border-[#FEF7F4] shadow-xl shadow-black/[0.03]">
//         <div className="flex flex-col lg:flex-row gap-10 items-start">
//           <div className="flex-1">
//             <h3 className="text-3xl font-semibold text-[#1a1a2e] mb-4 font-['Cormorant_Garamond'] tracking-tight">Custom Research Services</h3>
//             <p className="text-[#4a4a5a] leading-relaxed mb-6">
//               Beyond published reports, ASSOCHAM provides bespoke research on market sizing, competitor profiling, pricing strategies, regulatory pathways, and partnership structures tailored to member priorities.
//             </p>
//             <div className="grid gap-3 sm:grid-cols-2">
//               {services.map((item) => (
//                 <div key={item} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 border border-[#FEF7F4] shadow-sm">
//                   <FiAward className="h-5 w-5 text-[#DB6400]" />
//                   <span className="text-sm font-medium text-[#2a2a3a]">{item}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="w-full lg:w-80 rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] p-8 text-white shadow-2xl shadow-[#DA2128]/20 flex flex-col justify-between">
//             <div>
//               <h4 className="text-xl font-semibold mb-3 font-['Outfit']">Request a Study</h4>
//               <p className="text-sm text-white/85 leading-relaxed mb-6">Share your market, sector, or country focus. Our research team delivers a tailored brief within 10 business days.</p>
//             </div>
//             <a href="#" className="block text-center rounded-full bg-[#F59C00] text-[#1a1a2e] font-bold py-3 shadow-xl shadow-black/10 hover:bg-[#FBBF24] transition-colors">Initiate Request →</a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }





// new new code 




import { useState } from "react";
import { FiFileText, FiAward, FiZap, FiDownload, FiLayers, FiBookOpen, FiArrowUpRight } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";

const reports = [
  { title: "Market Entry Guide — UAE", sector: "Energy & Logistics", pages: 42, status: "New", category: "Energy", date: "Jul 2026", desc: "Regulatory environment, logistics corridors, and investment incentives for Indian enterprises." },
  { title: "Sector Brief — Germany Automotive", sector: "Manufacturing / Auto", pages: 28, status: "Updated", category: "Manufacturing", date: "Jun 2026", desc: "EV supply chain dynamics, component sourcing trends, and strategic alliances with German OEMs." },
  { title: "Trade Intelligence — USA Pharma", sector: "Healthcare / Pharma", pages: 35, status: "New", category: "Healthcare", date: "May 2026", desc: "FDA pathways, distribution networks, pricing frameworks, and clinical trial collaboration models." },
  { title: "Investment Outlook — Japan Retail", sector: "Retail / Consumer", pages: 30, status: "Updated", category: "Consumer", date: "Apr 2026", desc: "E-commerce regulations, omnichannel strategies, and consumer behavior shifts." },
  { title: "Agricultural Export — Brazil", sector: "Agriculture / Food", pages: 22, status: "Updated", category: "Agriculture", date: "Mar 2026", desc: "Procurement channels, quality certification requirements, and logistics from port to market." },
  { title: "Infrastructure Report — South Africa", sector: "Infrastructure / Energy", pages: 36, status: "New", category: "Energy", date: "Feb 2026", desc: "Road, rail, and power projects open to foreign investment; PPP frameworks." },
];

const categories = ["All Focus Areas", "Energy", "Manufacturing", "Healthcare", "Agriculture", "Consumer"];

const services = [
  "Market sizing & forecasting",
  "Competitor benchmarking",
  "Regulatory pathway mapping",
  "Partnership structuring",
];

export default function CountryCommercialReports() {
  const [selectedCategory, setSelectedCategory] = useState("All Focus Areas");

  const filteredReports = selectedCategory === "All Focus Areas"
    ? reports
    : reports.filter((r) => r.category === selectedCategory);

  return (
    <section id="reports" className="scroll-mt-20 py-4 max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-gray-100 pb-5">
        <div>
          <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-[#DB6400]/10 px-3 py-1 text-xs font-semibold text-[#DB6400]">
            <FiZap className="h-3.5 w-3.5 animate-pulse" />
            <span>Research Repository</span>
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-semibold text-[#1a1a2e] leading-tight tracking-tight">
            Commercial <span className="italic font-normal text-[#DB6400]">Reports & Studies</span>
          </h2>
        </div>

        {/* Category Filter Pills */}
        <div className="flex flex-wrap items-center gap-1.5 bg-[#FAF7F2] p-1.5 rounded-2xl border border-gray-100">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-3 py-1.5 text-xs font-semibold rounded-xl transition-all duration-200 ${
                selectedCategory === cat
                  ? "bg-[#DB6400] text-white shadow-md shadow-[#DB6400]/20"
                  : "text-[#6a6a7a] hover:text-[#1a1a2e] hover:bg-white/60"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Unique Document Library / Horizontal Row List Layout */}
      <motion.div layout className="space-y-3">
        <AnimatePresence>
          {filteredReports.map((r) => (
            <motion.div
              key={r.title}
              layout
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
              className="group flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-2xl bg-white border border-[#FEF7F4] p-4 md:p-5 shadow-sm hover:shadow-md hover:border-[#DB6400]/30 transition-all duration-300"
            >
              {/* Left Side: Report Details */}
              <div className="flex items-start gap-4 min-w-0">
                <div className="shrink-0 h-11 w-11 rounded-xl bg-[#FAF7F2] text-[#DB6400] group-hover:bg-[#DB6400] group-hover:text-white flex items-center justify-center text-xl transition-colors duration-300 border border-gray-100">
                  <FiBookOpen />
                </div>

                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2.5 mb-1 flex-wrap">
                    <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-md ${
                      r.status === "New" ? "bg-[#DA2128]/10 text-[#DA2128]" : "bg-[#DB6400]/10 text-[#DB6400]"
                    }`}>
                      {r.status}
                    </span>
                    <span className="text-xs font-semibold text-[#DB6400] flex items-center gap-1">
                      <FiLayers className="h-3 w-3" /> {r.sector}
                    </span>
                    <span className="text-[11px] text-[#9a9aab]">• {r.pages} Pages</span>
                    <span className="text-[11px] text-[#9a9aab]">• Published {r.date}</span>
                  </div>

                  <h3 className="text-base font-semibold text-[#1a1a2e] font-['Outfit'] group-hover:text-[#DB6400] transition-colors truncate">
                    {r.title}
                  </h3>

                  <p className="text-xs text-[#6a6a7a] line-clamp-1 mt-0.5">
                    {r.desc}
                  </p>
                </div>
              </div>

              {/* Right Side: Action Button */}
              <div className="shrink-0 flex items-center justify-end border-t sm:border-t-0 pt-3 sm:pt-0 border-gray-100">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 rounded-xl bg-[#FAF7F2] hover:bg-[#DB6400] text-[#1a1a2e] hover:text-white px-4 py-2.5 text-xs font-semibold transition-all duration-200"
                >
                  <FiDownload className="h-3.5 w-3.5" />
                  <span>Download Report</span>
                </a>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>

      {/* Integrated Research Request Banner */}
      {/* <div className="rounded-3xl bg-gradient-to-r from-[#1a1a2e] via-[#2a2a40] to-[#1a1a2e] p-6 md:p-8 text-white shadow-xl shadow-black/10 relative overflow-hidden">
        <div className="absolute top-0 right-0 h-48 w-48 rounded-full bg-[#DB6400]/15 blur-3xl pointer-events-none" />

        <div className="relative z-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="space-y-2 max-w-2xl">
            <div className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-[11px] font-medium text-white/90">
              <FiFileText className="h-3.5 w-3.5 text-[#F59C00]" /> Tailored Research
            </div>
            <h3 className="text-2xl md:text-3xl font-semibold font-['Cormorant_Garamond'] tracking-tight text-white">
              Need a Custom Market Research Study?
            </h3>
            <p className="text-xs md:text-sm text-white/80 leading-relaxed font-light">
              Get custom market sizing, competitor benchmarking, and regulatory mapping tailored specifically to your business goals.
            </p>
          </div>

          <a
            href="#"
            className="shrink-0 inline-flex items-center gap-2 rounded-xl bg-[#F59C00] hover:bg-[#FBBF24] text-[#1a1a2e] font-bold text-xs py-3 px-6 shadow-md transition-colors"
          >
            Request Custom Study <FiArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div> */}
    </section>
  );
}